// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"455":"8b9d3710","488":"3f4d7a2d","770":"8b9d3710","771":"2d047091","881":"8b9d3710"}[chunkId] + ".chunk.css";
};